import * as React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { Badge, Box, Grid } from "@mui/material"

import { userData } from "@signals"


export default function StockAssortmentFooterInfo() {
    const customerID = userData.value?.customerID
    const clickAndCollect = !!userData.value?.clickAndCollect

    const info = [{
        color: 'success',
        customColor: false,
        text: 'Product in stock: currently available'
    }, ...(clickAndCollect ? [{
        color: 'warning',
        customColor: false,
        text: 'Click and Collect: currently available for click and collect' + (customerID === 6 ? ' (Carrefour.fr only)' : '')
    }] : []), {
        color: 'error', 
        customColor: false,
        text: 'Product out of stock: visible but currently not available OR not visible in the last 30 days'
    }, {
        color: 'disabled.light',
        customColor: true,
        text: 'Product deslisted: removed from the website'
    }, {
        color: 'disabled.darker',
        customColor: true,
        text: 'Product Not Listed: has never been listed by the retailer'
    }, {
        color: '#2196F3',
        customColor: true,
        text: 'Not Launched: deslisted or not listed but not yet available (future street date)'
    }]

    return <Grid container sx={{ width: .7 }} alignItems="top">
        <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconSeeker icon="info-circle" iconType="fontAwesome" size="medium" iconWeight="regular" sx={{ fontSize: '3rem', mr: 1, mt: -0.5 }}/>
        </Grid>
        <Grid item xs={10}>
            <Box sx={{ fontWeight: 'bold', fontSize: '1.5rem', pb: 1 }}>Badge colors table info</Box>
            { info.map(( item, idx ) => <Box key={idx} sx={{ pl: 4 }}>
                {!item.customColor && <Badge color={item.color} badgeContent=" " /> }
                {item.customColor && <Badge sx={{ span: { backgroundColor: item.color } }} badgeContent=" " /> }
                <Box component="span" sx={{ ml: 2, verticalAlign: 'middle' }}>{item.text}</Box>
            </Box>) }
        </Grid>
    </Grid>
}